module.exports = __webpack_public_path__ + "img/Map_5__First_CanalNMC_29139_Niagara_and_First_Welland_Canal.d713aa04.jpg";